module.exports = __webpack_public_path__ + "media/images/login-loading-3bb519fdba7246d2a3a4b564b16b1036.gif";